import { useEffect } from "react";
import { useHistory } from "react-router-dom";

// convert dreamchimney tracks links from href to react-router Link

export default () => {
  const history = useHistory();

  useEffect(() => {
    const regExReplace = /https?:\/\/(www\.)?dreamchimney\.com\/tracks/;

    document.querySelectorAll(".track-comment a, .body-comment a").forEach((a) => {
      a.addEventListener("click", (ev) => {
        const href = a.getAttribute("href") || null;

        if (regExReplace.test(href) || href.startsWith("/tracks")) {
          const hrefRelative = href.replace(regExReplace, "").replace("/tracks", "");
          ev.preventDefault();
          history.push(hrefRelative);
        }
      });
    });
  });
};
